enum JoinToSpeakRole {
  Host,
  Speaker,
  Audience,
}

// eslint-disable-next-line import/prefer-default-export
export { JoinToSpeakRole }
